import React from 'react';
import classNames from 'classnames';

type Props = {
  big?: boolean;
  small?: boolean;
  className?: string;
};

export const UiSpinner: React.FC<Props> = ({ big, small, className }: Props) => (
  <div className={classNames('preloader-wrapper active', { big, small }, className)}>
    <div className="spinner-layer spinner-blue-only">
      <div className="circle-clipper left">
        <div className="circle" />
      </div>
      <div className="gap-patch">
        <div className="circle" />
      </div>
      <div className="circle-clipper right">
        <div className="circle" />
      </div>
    </div>
  </div>
);
